import React from 'react';
import PriorityBadge from './PriorityBadge';
import { formatScore } from '../lib/capacityPlanningFormatters';

const ExpansionCandidatePanel = ({ items = [], onOpenDetail }) => {
  const top = Array.isArray(items) ? items.slice(0, 4) : [];
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/80 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-100">Kandidat Ekspansi Prioritas Tinggi</h3>
      </div>
      <div className="grid gap-3 lg:grid-cols-2">
        {top.length === 0 ? (
          <p className="text-sm text-slate-400">Belum ada kandidat prioritas.</p>
        ) : top.map((item) => (
          <button
            type="button"
            key={item.candidateId}
            onClick={() => onOpenDetail?.(item)}
            className="rounded-lg border border-slate-800 bg-slate-950/80 p-3 text-left hover:border-slate-700"
          >
            <div className="mb-2 flex items-center justify-between gap-2">
              <PriorityBadge priority={item.priorityClass} />
              <span className="text-xs text-slate-400">Urgensi {formatScore(item.urgencyScore)}</span>
            </div>
            <p className="text-sm font-semibold text-slate-100">{item.title}</p>
            <p className="mt-1 text-xs text-slate-400">{item.scopeType} • {item.scopeKey}</p>
            <p className="mt-2 text-xs text-slate-300">{item.recommendedAction}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExpansionCandidatePanel;
